import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';
import moment from 'moment';
import cn from 'classnames';
import { useField } from 'react-final-form';
import TextTruncate from 'react-text-truncate';

import { createFormField } from 'Shared/utils/createFormField';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

import './index.scss';

function RecurringMeeting({
  value: recurringMeeting,
  name,
  isGroupType,
  currentUserEmail,
  currentUserId = null,
}: AnyObject) {
  const {
    input: { onChange: onSelectedChange },
  } = useField(`${name}.selected`);

  const currentUserFromMeeting = recurringMeeting.attendees?.find(({ userId }) => userId === currentUserId);
  const teammate = currentUserFromMeeting
    ? recurringMeeting.attendees?.find(({ userId }) => userId !== currentUserId)
    : recurringMeeting.attendees?.find(({ email }) => email !== currentUserEmail);
  const teammateEmail = isGroupType ? null : teammate?.email;

  const handleClick = useCallback(
    () => onSelectedChange(!recurringMeeting.selected),
    [onSelectedChange, recurringMeeting.selected]
  );

  if (!recurringMeeting) return null;

  return (
    <div
      className={cn('RecurringMeeting d-flex w-100 mb-3 cursor-pointer', {
        'RecurringMeeting--selected': recurringMeeting.selected,
      })}
      onClick={handleClick}
    >
      <div className={cn('d-flex w-100', { 'align-items-center': !teammateEmail })}>
        <StyledCheckbox
          className={cn('RecurringMeeting__checkbox', {
            'RecurringMeeting__checkbox--center align-self-center': !teammateEmail,
          })}
          checked={recurringMeeting.selected}
          onChange={() => null}
        />
        <div className="mr-2 w-100">
          <div className="RecurringMeeting__title">
            <TextTruncate line={2} truncateText="…" text={recurringMeeting.name} />
          </div>
          {teammateEmail && <div className="RecurringMeeting__info">{teammateEmail}</div>}
        </div>
      </div>
      <div className="RecurringMeeting__date-info d-none d-sm-flex flex-column align-items-end justify-content-center">
        {recurringMeeting.nextEventDate && (
          <div className="RecurringMeeting__info">{moment(recurringMeeting.nextEventDate).calendar()}</div>
        )}
        {recurringMeeting.frequency && (
          <div className="RecurringMeeting__info text-right">{recurringMeeting.frequency}</div>
        )}
      </div>
    </div>
  );
}

export default createFormField(RecurringMeeting);
